/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { CustomMaterialTable } from '../../Common/CustomMaterialTable';
import services from '../Service';

var screenCode = "DAILYPERFORMORDERSVIEW"

let headCells = [
    {
        id: 'factoryName',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'Factory Name'
    },
    {
        id: 'productCode',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'SKU'
    },

    {
        id: 'productName',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'Product Name'

    },
    {
        id: 'quantity',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'Quantity(kg)'

    },
    {
        id: 'orderDate',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'Order Date'
    },

];

export default function DailyPerformOrdersView(props) {

    const navigate = useNavigate();

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Daily Perform Orders'
    });

    const [datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [plotDetails, setPlotDetails] = useState([]);
    const [value, setValue] = useState(0);


    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: new Date(datevalue).toISOString()
    });

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const viewGrnInformationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(0, 'Please Select Operation Entity').required('Operation Entity required'),
        date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            date: formData.date
        },

        validationSchema: viewGrnInformationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
            setIsHidden(true)
        }
    });

    //tobackend
    async function SubmitForm() {
        let res = await services.GetDailyPerformOrderDetails(
            formik.values.groupID,
            formik.values.operationEntityID,
            new Date(datevalue).toISOString().split('T')[0],
        );
        res.forEach(x => {
            x.orderDate = x.orderDate.split('T')[0];
        });
        setPlotDetails(res)
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        formik.resetForm();
        setPlotDetails([]);
        setDateValue(new Date().setDate(new Date().getDate()));
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'DAILYPERFORMORDERSVIEW');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());

    }

    return (
        <>
            <LoadingComponent />
            <Page title="Daily Perform Orders   |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Operation Entity *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>All</MenuItem>
                                        {operationEntityList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error"
                                        onClick={() => clearAll()}
                                    >
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined"
                                    >
                                        Search
                                    </Button>
                                </Stack>
                                <br />
                                <Divider variant="middle" />
                                <br />
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {plotDetails.length != 0 ? (
                                            <Card>
                                                <TableContainer>
                                                    <CustomMaterialTable
                                                        headCells={headCells}
                                                        tableData={plotDetails}
                                                    />
                                                </TableContainer>
                                            </Card>
                                        ) : null}
                                    </Stack>
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}